import { render, staticRenderFns } from "./SigninRedirect.vue?vue&type=template&id=a19537f4&"
import script from "./SigninRedirect.vue?vue&type=script&lang=js&"
export * from "./SigninRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports